import React from 'react';

export function ProfileModal({ user }) {
    return (
        <>
            <div className="ui basic modal" id={"profileModal"}>
                <i className={"close icon"}></i>
                <Profile user={user}/>
            </div>
        </>
    )
}

function Profile({ user }) {

    let DisplayBlock;

    if(user !== null && user !== undefined && "email" in user) {
        console.log("user is: "+JSON.stringify(user));
        DisplayBlock = (
            <>
                {user.firstName} {user.lastName}
                <div className="meta">
                    <span className="date"> {user.email} </span>
                </div>
            </>)
    } else {
        DisplayBlock = (<> Logger User Not Found ! </>)
    }

    return (
            <>
                <div className={"ui icon header"}>
                    <i className={"user circle icon"}></i>
                    {DisplayBlock}
                </div>
            </>
        )
}